import axios from "axios"
import {
  RenovacaoTokenEntrada,
  RenovacaoTokenResposta,
} from "@/repositorios/autenticacao/autenticacao.modelo"
import SessaoServico from "@/servicos/sessao.service"

const clienteRefresh = axios.create({
  baseURL: process.env.VUE_APP_GESTAO_BASE_URL,
})

export function renovarToken(
  refreshToken: string,
  tipoToken: string,
  accessToken: string
): Promise<RenovacaoTokenResposta> {
  if (SessaoServico.ehSessaoKeycloak) {
    return renovarTokenKeycloak(refreshToken)
  }

  const dados: RenovacaoTokenEntrada = {
    refresh_token: refreshToken,
  }

  return clienteRefresh
    .post<RenovacaoTokenResposta>("/api/autenticacao/refresh", dados, {
      headers: {
        Authorization: `${tipoToken} ${accessToken}`,
      },
    })
    .then((resposta) => resposta.data)
}

function renovarTokenKeycloak(
  refreshToken: string
): Promise<RenovacaoTokenResposta> {
  if (!SessaoServico.urlRenovacaoTokenKeycloak) {
    return Promise.reject(new Error("Sessão do Keycloak sem URL de renovação"))
  }

  const dados = new URLSearchParams({
    grant_type: "refresh_token",
    client_id: "pontotel",
    refresh_token: refreshToken,
  })

  return axios
    .post<RenovacaoTokenResposta>(
      SessaoServico.urlRenovacaoTokenKeycloak,
      dados,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    )
    .then((resposta) => resposta.data)
}
